export default __webpack_public_path__ + "home.0d07421.png";